export default "__VITE_ASSET__BYHKO5Gf__"